import React from "react";
import { Form, InputGroup } from "react-bootstrap";

const HOURS = [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];

function buildMinutes(step) {
  const out = [];
  for (let m = 0; m < 60; m += step) out.push(String(m).padStart(2, "0"));
  return out;
}

function parse(value, step) {
  if (!value) return { hour: 8, minute: "00", ampm: "AM" };
  const [h, m] = value.split(":").map(Number);
  return {
    hour: h % 12 === 0 ? 12 : h % 12,
    minute: String(Math.round(m / step) * step % 60).padStart(2, "0"),
    ampm: h < 12 ? "AM" : "PM",
  };
}

function to24h(hour, minute, ampm) {
  let h = Number(hour);
  if (ampm === "AM") h = h === 12 ? 0 : h;
  else h = h === 12 ? 12 : h + 12;
  return `${String(h).padStart(2, "0")}:${minute}`;
}

export default function TimePicker({ value, onChange, disabled, minuteStep = 15 }) {
  const minutes = buildMinutes(minuteStep);
  const { hour, minute, ampm } = parse(value, minuteStep);

  const emit = (h, m, ap) => onChange(to24h(h, m, ap));

  return (
    <InputGroup>
      <Form.Select
        value={hour}
        onChange={(e) => emit(e.target.value, minute, ampm)}
        disabled={disabled}
        style={{ maxWidth: "75px" }}
        aria-label="Hour"
      >
        {HOURS.map((h) => (
          <option key={h} value={h}>{h}</option>
        ))}
      </Form.Select>
      <Form.Select
        value={minute}
        onChange={(e) => emit(hour, e.target.value, ampm)}
        disabled={disabled}
        style={{ maxWidth: "70px" }}
        aria-label="Minute"
      >
        {minutes.map((m) => (
          <option key={m} value={m}>{m}</option>
        ))}
      </Form.Select>
      <Form.Select
        value={ampm}
        onChange={(e) => emit(hour, minute, e.target.value)}
        disabled={disabled}
        style={{ maxWidth: "75px" }}
        aria-label="AM/PM"
      >
        <option value="AM">AM</option>
        <option value="PM">PM</option>
      </Form.Select>
    </InputGroup>
  );
}
